var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.93942 3.22635C7.93942 2.63589 8.18313 2.06961 8.61693 1.65208C9.05072 1.23456 9.63908 1 10.2526 1C10.866 1 11.4544 1.23456 11.8882 1.65208C12.322 2.06961 12.5657 2.63589 12.5657 3.22635C13.8939 3.83084 15.0262 4.7718 15.8412 5.9484C16.6561 7.125 17.1231 8.49287 17.192 9.90541V13.2449C17.279 13.937 17.5337 14.5997 17.9354 15.1798C18.3372 15.7598 18.8749 16.241 19.5051 16.5845H1C1.63026 16.241 2.16792 15.7598 2.56968 15.1798C2.97145 14.5997 3.2261 13.937 3.31314 13.2449V9.90541C3.38203 8.49287 3.84898 7.125 4.66396 5.9484C5.47893 4.7718 6.61121 3.83084 7.93942 3.22635",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7832 16.5845V17.6976C6.7832 18.5833 7.14876 19.4328 7.79946 20.059C8.45016 20.6853 9.3327 21.0372 10.2529 21.0372C11.1732 21.0372 12.0557 20.6853 12.7064 20.059C13.3571 19.4328 13.7227 18.5833 13.7227 17.6976V16.5845",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/BellIcon.f46a3da4570d4e71f471d0cdaf3e50ea.svg";
export { ForwardRef as ReactComponent };